import React from "react";
import "./Process.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faLightbulb,
  faPenNib,
  faRocket,
  faArrowsRotate,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";

const fadeUp = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
};

const steps = [
  {
    title: "Discovery Call",
    description: "We learn about your business, goals, target audience, and current digital challenges in a free consultation.",
    icon: faChartLine,
    bullets: ["Goal alignment", "Audience analysis", "Competitor review"],
  },
  {
    title: "Strategy & Proposal",
    description: "You receive a detailed proposal with scope, timeline, deliverables, and pricing — no hidden fees.",
    icon: faLightbulb,
    bullets: ["Custom roadmap", "Clear pricing", "Milestone plan"],
  },
  {
    title: "Design & Content",
    description: "We create wireframes, visual designs, and compelling copy that reflects your brand and converts visitors.",
    icon: faPenNib,
    bullets: ["UI/UX design", "Brand-aligned copy", "Client feedback rounds"],
  },
  {
    title: "Development & Launch",
    description: "Our developers build your site with performance, SEO, and mobile responsiveness as top priorities.",
    icon: faRocket,
    bullets: ["Clean code", "SEO foundation", "Testing & QA"],
  },
  {
    title: "Help & Growth",
    description: "Post-launch we provide ongoing help, run marketing campaigns, and optimize based on real performance data.",
    icon: faArrowsRotate,
    bullets: ["30-day care", "Marketing setup", "Monthly reports"],
  },
];

const Process = () => {
  return (
    <section className="prc" aria-label="Our process">
      <div className="prc__wrap">
        <motion.div
          className="prc__head"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.35 }}
          variants={fadeUp}
        >
          <div>
            <div className="prc__badge">
              <span className="dot" aria-hidden="true" />
              How We Work
            </div>
            <h2 className="prc__title">
              A clear process from <span>idea to launch</span>.
            </h2>
            <p className="prc__sub">
              No confusion, no surprises. You'll always know what's happening,
              what's next, and when to expect deliverables.
            </p>
          </div>
          <div className="prc__aside">
            <b>Communication:</b>
            <p>Weekly progress updates · shared project dashboard · direct access to your project lead</p>
          </div>
        </motion.div>

        <div className="prc__grid">
          {steps.map((s, i) => (
            <motion.div
              key={i}
              className="prc__card"
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.25 }}
              variants={fadeUp}
              transition={{ delay: i * 0.06 }}
            >
              <div className="prc__top">
                <div className="prc__step">
                  <span className="prc__stepDot" aria-hidden="true" />
                  Step {String(i + 1).padStart(2, "0")}
                </div>
                <div className="prc__icon" aria-hidden="true">
                  <FontAwesomeIcon icon={s.icon} />
                </div>
              </div>
              <h3 className="prc__h3">{s.title}</h3>
              <p className="prc__p">{s.description}</p>
              <ul className="prc__bullets">
                {s.bullets.map((b, idx) => <li key={idx}>{b}</li>)}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
